/**
 * Reading GeoJSON feature properties.
 *
 * Everything in `properties` has been through JSON and through MapLibre, which
 * hands back strings for values the source declared as numbers. Coercing at each
 * call site is how the legacy page ended up with `'12' + 1` in a total and
 * `Number(null) === 0` in a percentage; these three helpers are the only place
 * that coercion happens.
 */

/** A property as a finite number, or null for anything that is not one. */
export function num(value: unknown): number | null {
  if (value == null || value === "") return null;
  const n = Number(value);
  return Number.isFinite(n) ? n : null;
}

/**
 * A property as a number, defaulting to zero.
 *
 * Only for counts that are summed, where absent genuinely means none. Never for
 * a measurement: `fmt` prints '–' for null on purpose, and a zero there would
 * assert something the pipeline did not compute.
 */
export function count(value: unknown): number {
  return num(value) ?? 0;
}

/** A property as a non-empty string, or null. */
export function str(value: unknown): string | null {
  return typeof value === "string" && value.length > 0 ? value : null;
}
